// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ea0a96e072b2488c684d82758655aa6fccf9969f.chunk.bundle.js";
};